<table [formGroup]="parentFormGroup" class="critical-table">
  <thead>
    <tr>
      <th class="title"></th>
      <th class="title">Ponto Crítico/Risco</th>
      <th class="text-center">Tipo</th>
      <th class="text-center">Status</th>
      <th class="text-center">Probabilidade</th>
      <th class="text-center">Impacto</th>
      <th class="text-center">Sinaleira</th>
      <th class="text-center">Atualização</th>
    </tr>
  </thead>
  <tbody formGroupName="criticals">
    <ng-container *ngFor="let cri of criticals?.controls; let i = index"  [formGroupName]="i">
      <tr *ngIf="currentItem[i] as variable" class="tr-{{i % 2}}">
        <td class=" align-top">
          <span class="font-icon pointer"  *ngIf="variable?.pf_ind_action?.length > 0" (click)="variable['show_table'] = variable['show_table'] != null? !variable['show_table']:true"> 
            keyboard_arrow_{{variable?.show_table? 'up':'down'}}
          </span>
        </td>
        <td class="d-flex justify-content-start">
          <div>
            <input type="checkbox" class="mt-1 me-2" [checked]="variable?.checkeds" formControlName="checkeds" />
          </div>
          <span>
            {{variable?.description}}
          </span>
        </td>
        <td class="text-center">{{variable?.pf_critical_type?.name}}</td>
        <td class="text-center">{{variable?.pf_ind_critical_stat?.name}}</td>
        <td class="text-center">{{variable?.pf_critical_probability?.name}}</td>
        <td class="text-center">{{variable?.pf_critical_impact?.name}}</td>
        <td class="text-center">
          <div class="dot dot-critical-{{getStatus(variable)}}" title="{{status[getStatus(variable)]}}" ></div>
        </td>
        <td class="text-center">{{variable?.tb_pss_pessoa_ctr_atu?.str_nome}} <br/> {{variable?.ctr_dth_atu | date: 'dd/MM/YYYY'}}</td>
      </tr>
      <ng-container *ngIf="currentItem[i] as variable">
        <tr *ngIf="variable.show_table == true" class="tr-{{i % 2}}">
          <td colspan="9"  class="active-td break-word td-description">
            <app-itens-ind-action
              [parentFormGroup]="cri"
              [currentItem]="variable?.pf_ind_action" formName="actions">
          </app-itens-ind-action>
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table> 